import { render, staticRenderFns } from "./QuizComponent.vue?vue&type=template&id=290dbd79"
import script from "./QuizComponent.vue?vue&type=script&lang=js"
export * from "./QuizComponent.vue?vue&type=script&lang=js"
import style0 from "./QuizComponent.vue?vue&type=style&index=0&id=290dbd79&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports